// extracted by mini-css-extract-plugin
export default {"container":"groupContainer_container__Bba2-"};